export * from "./CustomShippingOptionWidgetVariantEmbedded";
